import { Note } from "tonal";

// Better enharmonic equivalent that prioritizes alphabetical sequences
const getOptimalEnharmonics = (noteNames) => {
  const result = [...noteNames];
  
  // Process each note and try to create the best alphabetical sequence
  for (let i = 0; i < result.length; i++) {
    const note = Note.get(result[i]);
    if (!note.alt) continue; // Skip natural notes
    
    const enharmonic = Note.enharmonic(result[i]);
    if (!enharmonic) continue;
    
    const currentLetter = note.letter;
    const enhLetter = Note.get(enharmonic).letter;
    
    // Get all letters used so far in the optimized sequence
    const usedLetters = result.slice(0, i).map(n => Note.get(n).letter);
    
    // Rule 1: Avoid duplicate letter names if possible
    const currentLetterUsed = usedLetters.includes(currentLetter);
    const enhLetterUsed = usedLetters.includes(enhLetter);
    
    if (currentLetterUsed && !enhLetterUsed) {
      result[i] = enharmonic;
      continue;
    }
    
    if (!currentLetterUsed && enhLetterUsed) {
      continue; // Keep current
    }
    
    // Rule 2: Try to maintain alphabetical progression
    if (i > 0) {
      const prevLetter = Note.get(result[i-1]).letter;
      const prevLetterCode = prevLetter.charCodeAt(0);
      const currentLetterCode = currentLetter.charCodeAt(0);
      const enhLetterCode = enhLetter.charCodeAt(0);
      
      // Calculate distance in alphabetical sequence (with wrap-around)
      const getDistance = (from, to) => {
        let dist = to - from;
        if (dist < 0) dist += 7; // Wrap around (A=0, B=1, ..., G=6)
        return dist;
      };
      
      const currentDistance = getDistance(prevLetterCode, currentLetterCode);
      const enhDistance = getDistance(prevLetterCode, enhLetterCode);
      
      // Prefer the option that creates a smaller alphabetical jump
      // (but avoid going backwards unless necessary)
      if (enhDistance > 0 && enhDistance < currentDistance) {
        result[i] = enharmonic;
      }
    }
  }
  
  return result;
};

export default getOptimalEnharmonics;